import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';


export interface Action
{
    Id: string
    Name: string
    TypeId: string
    MethodId: string
}

@Injectable({
  providedIn: 'root'
})
export class ActionsService {

  constructor(
    private http: HttpClient
  ) { }

  private readonly url = `${environment.API_INSPEC}Action`

  getActions(assetId: string): Observable<Action[]> {
    return this.http.get<Action[]>(this.url + `?assetId=${assetId}`)
    .pipe(
      catchError(error => {
        console.error('Error fetching actions:', error);
        return of([]);
      })
    )
  }
}